module.exports = __webpack_public_path__ + "static/media/stand-rocket.965e2130.png";